import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { communicationKeys } from "@/domains/communication/api/keys";
import { caseKeys } from "@/domains/cases";
import type { EmailTemplate, SentEmail } from "@/domains/communication/api/types";
import {
  deleteTemplate,
  saveTemplate,
  sendEmail,
} from "@/domains/communication/mocks/communicationService";

export function useSaveTemplate(): UseMutationResult<EmailTemplate, Error, EmailTemplate> {
  const client = useQueryClient();
  return useMutation({
    mutationFn: saveTemplate,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: communicationKeys.templates() });
    },
  });
}

export function useDeleteTemplate(): UseMutationResult<void, Error, string> {
  const client = useQueryClient();
  return useMutation({
    mutationFn: deleteTemplate,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: communicationKeys.templates() });
    },
  });
}

export function useSendEmail(): UseMutationResult<
  SentEmail,
  Error,
  Omit<SentEmail, "id" | "sentAt">
> {
  const client = useQueryClient();
  return useMutation({
    mutationFn: sendEmail,
    onSuccess: (email) => {
      client.invalidateQueries({ queryKey: communicationKeys.sent() });
      client.invalidateQueries({ queryKey: communicationKeys.sentByCase(email.caseId) });
      client.invalidateQueries({ queryKey: caseKeys.detail(email.caseId) });
    },
  });
}
